module.exports = __webpack_public_path__ + "static/media/TypingSpeedTester.d61030d1.png";